export enum HUN_CHOICE {
  HUNDERASSEN = 'hunderassen',
}
